import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@heroui/react";

import { useDialog } from "../../contexts/DialogContext";
import { Inhibit } from "./Inhibit";
import { Normal } from "./Normal";
import { Trust } from "./Trust";

export const LoginModal = () => {
  const { state, dispatch } = useDialog();
  const { isOpen, onClose } = useDisclosure({
    isOpen: "LOGIN_INFO" in state.dialogs,
    onClose: () => dispatch({ action: "CLOSE_DIALOG", dialogId: "LOGIN_INFO" }),
  });

  const myState = state.dialogs.LOGIN_INFO;

  return (
    <Modal isOpen={isOpen} onOpenChange={onClose}>
      <ModalContent className="canvas-overlay-card">
        {(_onClose) => (
          <>
            <ModalHeader>Login</ModalHeader>
            <ModalBody>
              {myState?.mode === "INHIBIT" && <Inhibit />}
              {myState?.mode === "TRUST" && <Trust />}
            </ModalBody>
            {myState?.mode === "NORMAL" && <Normal state={myState} />}
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
